@use "../../mixins/index.scss" as anchor;

// TODO: Need to establish where we put our global scss mixins
@mixin transform($transforms) {
  -webkit-transform: $transforms;
  -moz-transform: $transforms;
  -ms-transform: $transforms;
  transform: $transforms;
}
@mixin rotate($deg) {
  @include transform(rotate(#{$deg}deg));
}
// transitions
@mixin transition($transitions) {
  -webkit-transition: $transitions;
  -moz-transition: $transitions;
  transition: $transitions;
}

:host {
  /** @prop --accordion-padding-size: Set the size of the padding around the accordion item. */
  --accordion-padding-size: var(--slotted-padding-size, 20px); // TODO - Need to figure out if we should use 16px or 24px.

  /**
   * @deprecated: kept for backwards compatibility, but will be removed by April 2024
   * @prop --padding-size: DEPRECATED: Use --accordion-padding-size instead. Kept for backwards compatibility, but will be removed by April 2024
   */
  --padding-size: var(--accordion-padding-size);

  /** @prop --accordion-padding-bottom: Set the size of the bottom padding. */
  --accordion-padding-bottom: var(--accordion-padding-vertical);

  /**
   * @deprecated: kept for backwards compatibility, but will be removed by April 2024
   * @prop --padding-bottom: DEPRECATED: Use --accordion-padding-bottom instead. Kept for backwards compatibility, but will be removed by April 2024
   */
  --padding-bottom: var(--accordion-padding-vertical);

  /** @prop --accordion-padding-horizontal: Set the size of the horizontal padding. */
  --accordion-padding-horizontal: calc(var(--slotted-padding-horizontal, var(--accordion-padding-size)) * 2);

  /**
   * @deprecated: kept for backwards compatibility, but will be removed by April 2024
   * @prop --padding-horizontal: DEPECATED: Use --accordion-padding-horizontal instead. Kept for backwards compatibility, but will be removed by April 2024
   */
  --padding-horizontal: var(--accordion-padding-horizontal);

  /** @prop --accordion-padding-shorthand: Set the shorthand for all padding values. */
  --accordion-padding-shorthand: var(--accordion-padding-top) var(--accordion-padding-right) var(--accordion-padding-bottom) var(--accordion-padding-left);

  /**
   * @deprecated: kept for backwards compatibility, but will be removed by April 2024
   * @prop --padding-shorthand: DEPRECATED: Use --accordion-padding-shorthand instead. Kept for backwards compatibility, but will be removed by April 2024
   */
  --padding-shorthand: var(--accordion-padding-top) var(--accordion-padding-right) var(--accordion-padding-bottom) var(--accordion-padding-left);

  /** @prop --accordion-padding-vertical: Set the size of the vertical padding. */
  --accordion-padding-vertical: var(--accordion-padding-size);

  /**
   * @deprecated: kept for backwards compatibility, but will be removed by April 2024
   * @prop --padding-vertical: DEPRECATED: Use --accordion-padding-vertical instead. Kept for backwards compatibility, but will be removed by April 2024
   */
  --padding-vertical: var(--accordion-padding-vertical);

  /** @prop --accordion-padding-top: Set the size of the top padding. */
  --accordion-padding-top: var(--accordion-padding-vertical);

  /**
   * @deprecated: kept for backwards compatibility, but will be removed by April 2024
   * @prop --padding-top: DEPRECATED: Use --accordion-padding-top instead. Kept for backwards compatibility, but will be removed by April 2024
   */
  --padding-top: var(--accordion-padding-top);

  /** @prop --accordion-padding-left: Set the size of the left padding. */
  --accordion-padding-left: var(--accordion-padding-horizontal);

  /**
   * @deprecated: kept for backwards compatibility, but will be removed by April 2024 
   * @prop --padding-left: DEPRECATED: Use --accordion-padding-left instead. Kept for backwards compatibility, but will be removed by April 2024
   */
  --padding-left: var(--accordion-padding-left);

  /** @prop --accordion-padding-right: Set the size of the right padding. */
  --accordion-padding-right: var(--accordion-padding-horizontal);

  /**
   * @deprecated: kept for backwards compatibility, but will be removed by April 2024
   * @prop --padding-right: DEPRECATED: Use --accordion-padding-right instead. Kept for backwards compatibility, but will be removed by April 2024
   */
  --padding-right: var(--accordion-padding-right);

  /** 
   * @deprecated: Replaced by `--accordion-chevron-margin-left`. Kept for backwards compatibility for now.
   * @prop --accordion-chevron-margin: DEPRECATED: Use --accordion-chevron-margin-left instead. Kept for backwards compatibility, but will be removed by February 2025
   */
  --accordion-chevron-margin: var(--accordion-padding-size);

  /** @prop --accordion-chevron-margin-top: Set the top margin on the chevron icon. */
  --accordion-chevron-margin-top: 0px;

  /** @prop --accordion-chevron-margin-right: Set the right margin on the chevron icon. */
  --accordion-chevron-margin-right: 0px;

  /** @prop --accordion-chevron-margin-bottom: Set the bottom margin on the chevron icon. */
  --accordion-chevron-margin-bottom: 0px;

  /** @prop --accordion-chevron-margin-left: Set the left margin on the chevron icon. */
  --accordion-chevron-margin-left: var(--accordion-chevron-margin, --accordion-padding-size);

  /** @prop --accordion-header-gap: Set the gap between header elements. */
  --accordion-header-gap: calc(var(--accordion-padding-size) / 2) var(--accordion-padding-size);

  /**
   * @deprecated: kept for backwards compatibility, but will be removed by April 2024
   * @prop --header-gap: DEPRECATED: Use --accordion-header-gap instead. Kept for backwards compatibility, but will be removed by April 2024
   */
  --header-gap: var(--accordion-header-gap);

  /** @prop --accordion-background-color: Set the background color of the accordion item. */
  --accordion-background-color: var(--slotted-background-color, var(--s-color-background-default-default));

  /** 
   * @deprecated: kept for backwards compatibility, but will be removed by April 2024.
   * @prop --background-color: DEPRECATED: Use --accordion-background-color instead. Kept for backwards compatibility, but will be removed by April 2024
   */
  --background-color: var(--accordion-background-color);

  /** @prop --accordion-border-color: Set the color of the accordion item border. */
  --accordion-border-color: var(--slotted-border-color, var(--s-color-border-divider));

  /**
   * @deprecated: kept for backwards compatibility, but will be removed by April 2024 
   * @prop --border-color: DEPRECATED: Use --accordion-border-color instead. Kept for backwards compatibility, but will be removed by April 2024
   */
  --border-color: var(--accordion-border-color);

  /** @prop --accordion-border-size: Set the size of the accordion item border. */
  --accordion-border-size: var(--p-size-static-0125);

  /** 
   * @deprecated: kept for backwards compatibility, but will be removed by April 2024
   * @prop --border-size: DEPRECATED: Use --accordion-border-size instead. Kept for backwards compatibility, but will be removed by April 2024
   */
  --border-size: var(--accordion-border-size);

  /** @prop --accordion-border-style: Set the style of the accordion item border. */
  --accordion-border-style: solid;

  /**
   * @deprecated: kept for backwards compatibility, but will be removed by April 2024
   * @prop --border-style: DEPRECATED: Use --accordion-border-style instead. Kept for backwards compatibility, but will be removed by April 2024
   */
  --border-style: var(--accordion-border-style);

  /** @prop --accordion-border: Set the shorthand for the accordion item border. */
  --accordion-border: var(--accordion-border-size) var(--accordion-border-style) var(--accordion-border-color);

  /**
   * @deprecated: kept for backwards compatibility, but will be removed by April 2024
   * @prop --border: DEPRECATED: Use --accordion-border instead. Kept for backwards compatibility, but will be removed by April 2024
   */
  --border: var(--border-size) var(--border-style) var(--border-color);

  /** @prop --accordion-box-sizing: Set the box sizing of the accordion item. */
  --accordion-box-sizing: border-box;

  /**
   * @deprecated: kept for backwards compatibility, but will be removed by April 2024 
   * @prop --box-sizing: DEPRECATED: Use --accordion-box-sizing instead. Kept for backwards compatibility, but will be removed by April 2024
   */
  --box-sizing: var(--accordion-box-sizing);

  .header-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--accordion-header-gap);
    width: 100%;
    @media screen and (max-width: anchor.$bp-extra-small) {
      flex-direction: column;
      align-items: flex-start;
    }
  }

  .header,
  .not-user-controlled-content,
  ::slotted(.content),
  ::slotted([slot|='content']) {
    --accordion-padding-shorthand: var(--accordion-padding-top) var(--accordion-padding-right) var(--accordion-padding-bottom) var(--accordion-padding-left);
    padding: var(--accordion-padding-shorthand);
  }
}

.box {
  box-sizing: var(--accordion-box-sizing);
  border: var(--accordion-border);
}

.anchor-c-accordion-item {
  background-color: var(--accordion-background-color);
  border-bottom: var(--accordion-border);
  color: var(--s-color-text-default);
  width: 100%;
  anchor-icon {
    color: var(--s-color-icon-brand);
  }
  &:not(.box).focused {
    box-shadow: inset 0 0 0 var(--accordion-border-size) var(--s-color-outline-default);
    .header anchor-icon {
      color: currentColor;
    }
  }
  &.box.focused {
    // custom focused handler because nested content.
    border-color: var(--s-color-outline-default);
    box-shadow: none;
    outline-color: var(--s-color-outline-default);
    outline-width: 2px;
    // border: var(--p-size-static-0125) solid var(--s-color-outline-default);
    .header anchor-icon {
      color: currentColor;
    }
  }
  .header {
    background-color: var(--slotted-background-color, var(--accordion-background-color));
    &:hover {
      filter: brightness(95%);
    }
    cursor: pointer;
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    anchor-icon {
      color: var(--s-color-icon-brand);
      margin: var(--accordion-chevron-margin-top) var(--accordion-chevron-margin-right) var(--accordion-chevron-margin-bottom) var(--accordion-chevron-margin-left);
      @include transition(transform 0.24s cubic-bezier(0.25, 0.46, 0.45, 0.94));
    }

    &--vertical-align-start {
      align-items: start;
    }

    &--vertical-align-center {
      align-items: center;
    }

    &--vertical-align-end {
      align-items: end;
    }

    &:hover anchor-icon {
      color: currentColor;
    }
    &:focus {
      outline-width: 0;
      box-shadow: none;
    }
  }
  .content-container {
    display: none;
  }
  &.expanded {
    .header anchor-icon {
      @include rotate(-180);
    }
    .content-container {
      display: block;
    }
  }
  &.reverse {
    display: flex;
    flex-direction: column-reverse;
    width: 100%;
    anchor-icon {
      @include rotate(180);
    }
    &.expanded anchor-icon {
      @include rotate(0);
    }
  }
}
